// extracted by mini-css-extract-plugin
export default {"text-wrapper":"W3qdo","main-title":"VH5Tt","textarea":"rZ27D","skills-input":"QA6mO","skills-select":"ul3tM","input-form":"TTa7_","select":"uRTbp"};